module.exports = __webpack_public_path__ + "img/img-buy-online-1.919f93fd.svg";